import React from 'react';
import './ValidationModal.css'; // Reutilizando os estilos do ValidationModal

const DevelopmentModal = ({ nodeName, onClose }) => {
  if (!nodeName) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="validation-modal-backdrop" onClick={handleBackdropClick}>
      <div className="validation-modal">
        <div className="validation-modal-header">
          <h3>🚧 Nó em Desenvolvimento</h3>
          <button className="validation-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="validation-modal-content">
          <p className="validation-modal-description">
            O nó <strong>&ldquo;{nodeName}&rdquo;</strong> ainda está em desenvolvimento e não pode ser usado no momento.
          </p>
          
          <div className="validation-modal-list">
            <div className="validation-item">
              <div className="validation-item-header">
                <span className="validation-item-number">💡</span>
                <span className="validation-item-title">O que isso significa?</span>
              </div>
              <ul className="validation-item-pendencies">
                <li>Este nó está sendo desenvolvido pela equipe de desenvolvimento</li>
                <li>Em breve estará disponível para uso nos seus fluxogramas</li>
                <li>Por enquanto, utilize apenas os nós que não possuem a etiqueta &ldquo;Em Desenvolvimento&rdquo;</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="validation-modal-footer">
          <button className="validation-modal-button primary" onClick={onClose}>
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
};

export default DevelopmentModal;